import dmPortalConfig from '@dm-portal/config';
import domain from '@framework/config/domain';
import isServer from '@framework/router/Next/isServer';
import shouldUseInternalNetwork from '@framework/router/Next/shouldUseInternalNetwork';

export default {
  getRpcUrl(): string {
    if (shouldUseInternalNetwork()) {
      return this.getInternalRpcUrl();
    }

    return !isServer()
      ? `${ domain.protocol }//${ window.location.host }/proxy/dm-portal/rpc`
      : `${ domain.protocol }//${ domain.apiDomain }/dm-portal/rpc`;
  },

  getInternalRpcUrl(): string {
    return `${ dmPortalConfig.api.internal }/dm-portal/rpc`;
  },
};
